/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/react";
import {Notification} from "./Notification.jsx";
import CurrentUser from "authClient/currentUser";


const ErrorHandler = function () {

    async function setUp() {
        if (process.env.NODE_ENV !== "development") {
            // Check if the user is a Dora Explorer user, if so, show all input and tests in the replay to help with debugging.
            let userInfo = await CurrentUser.getUserInfo()
            let isTestUser = userInfo?.["cognito:username"] === "535e72d8-7790-4a22-9b57-b205c72b31ca"

            Sentry.init({
                dsn: "https://89b3e5db890f4deeba00e3aa39af55bc@o4504888245288960.ingest.sentry.io/4504888268161024",
                integrations: [new BrowserTracing(), new Sentry.Replay({
                    maskAllText: !isTestUser,
                    maskAllInputs: !isTestUser
                })],
                // This sets the sample rate to be 10%. You may want this to be 100% while
                // in development and sample at a lower rate in production
                replaysSessionSampleRate: 0.1,
                // If the entire session is not sampled, use the below sample rate to sample
                // sessions when an error occurs.
                replaysOnErrorSampleRate: 1.0,
                tracesSampleRate: 1.0,
                release: "0.9"
            });
        }

    }


    function recordTrace(error) {
        console.error(error)
        Notification.createError("An unexpected error occurred ")
        if (process.env.NODE_ENV === "production") {
            Sentry.captureException(error);
        }
    }

    function recordError(error) {
        if (process.env.NODE_ENV === "production") {
            Sentry.captureMessage(error);
        } else {
            console.error(error)
        }
    }


    function startTransaction(name) {
        if (process.env.NODE_ENV === "production") {
            return Sentry.startTransaction({
                op: "transaction",
                name: name,
            });
        } else {
            return {
                finish: () => {
                }
            }
        }
    }

    function createError() {


    }

    function createFunctionError(functionInfos, errorData) {
        // the function arguments
        console.log(functionInfos);
        // the original error massage
        console.log(errorData.originalError?.info?.message);
    }

    function capturePossibleAttack(functionInfos, errorData, type) {
        // the function arguments
        console.log(functionInfos);
        // the original error massage
        console.log(errorData);
        // type of the attack
        console.log(type);
    }

    function possibleAttackType() {
        return {
            SQL_INJECTION: 'SQL_INJECTION',
            MATHJS_INJECTION: 'MATHJS_INJECTION',
            COUNTERFEIT_JWT_TOKEN: 'COUNTERFEIT_JWT_TOKEN',
        }

    }

    return {
        createFunctionError: createFunctionError,
        recordError: recordError,
        capturePossibleAttack: capturePossibleAttack,
        possibleAttackType: possibleAttackType(),
        fE: createFunctionError, setUp: setUp, recordTrace: recordTrace, startTransaction: startTransaction
    }

}()

export {
    ErrorHandler
};